import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/Admin/components/LoginView.vue'
import UsersManage from '../views/Admin/UsersManage/default.vue'

const routes = [
  {
    path: '/',
    redirect: '/nastenka'
  },
  {
    path: '/prihlaseni',
    name: 'login', // Ponechání jména pro cestu přihlášení
    component: LoginView
  },

  {
    path: '/nastenka',
    name: 'Nastenka',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/DashboardView.vue')
  },

  {
    path: '/form/:id', // Definice cesty s parametrem :id
    name: 'FormView',
    // Rozdělení kódu na úrovni route
    // Tímto způsobem se vygeneruje samostatný chunk (např. about.[hash].js)
    // který je lazy-loaded při návštěvě této cesty
    component: () => import(/* webpackChunkName: "form-view" */ '../views/MainForm/FormView.vue'),
    props: true // Nastavení props na true pro předání parametru :id do komponenty
},

{
  path: '/autocomplete', // Definice cesty s parametrem :id
  // Rozdělení kódu na úrovni route
  // Tímto způsobem se vygeneruje samostatný chunk (např. about.[hash].js)
  // který je lazy-loaded při návštěvě této cesty
  component: () => import(/* webpackChunkName: "form-view" */ '../views/MainForm/Autocomplete.vue'),
  props: true // Nastavení props na true pro předání parametru :id do komponenty
},

  {
    path: '/admin',
    name: 'Default',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/default.vue')
  },

  {
    path: '/dotaznik',
    name: 'Dotaznik',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Questionnaire/display.vue')
  },

  {
    path: '/fields',
    name: 'Fields',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Questionnaire/FieldsManage.vue')
  },


  {
    path: '/dotaznik/:id',
    name: 'DotaznikDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Questionnaire/detail.vue')
  },

  {
    path: '/uzivatele',
    name: 'Users', // Unikátní jméno pro root cestu
    component: UsersManage
  },
  {
    path: '/nastroje',
    name: 'Nastroje',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Tools/default.vue')
  },

  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
